<div class="course-modal-wrapper">
    <div class="course-modal-header">
        <div class="course-modal-img-title" *ngIf="courseTypeImg; else shimmerEffect"
            [ngStyle]="{'background': 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 1) 240px, rgba(255, 255, 255, 1) 290px), url(' + courseTypeImg + ') no-repeat center/cover'}">
            <div class="course-close-button" (click)="closeModal()">
                <img class="course-close-img" src="assets/icons/close-course.svg" alt="">
            </div>
            <span class="course-modal-title">Nouveau cours</span>
        </div>
        <ng-template #shimmerEffect>
            <div class="course-modal-img-title shimmer">
                <div class="course-close-button" (click)="closeModal()">
                    <img class="course-close-img" src="assets/icons/close-course.svg" alt="">
                </div>
                <span class="course-modal-title">Nouveau cours</span>
            </div>
        </ng-template>
        <span class="course-modal-description">{{ data.courseId? 'Modifier le cours' : 'Créer un nouveau cours'}}</span>
    </div>
    <div class="course-modal-body" *ngIf="!loading; else loader">
        <div class="select-wrapper">
            <label>Type du cours</label>
            <select class="select-content" [formControl]="castFormControl('courseType')"
                [ngClass]="{'has-error' : hasError('courseType', 'required')}">
                <option *ngFor="let item of data.clubsList" [ngValue]="item.id">
                    <span class="content">{{ item.name }}</span>
                </option>
            </select>
            <span *ngIf=" hasError('courseType', 'required')" class="error-message">
                Ce champ est requis*
            </span>
        </div>
        <div class="double-input">
            <app-webiat-text-input class="location-input" [label]="'Localisation'" [isLengthLimited]="false"
                [placeholder]="'Indiquer l’emplacement'" [control]="castFormControl('location')"
                (inputChanged)="onInputChange($event, 'location')">
            </app-webiat-text-input>
            <app-webiat-text-input class="places-input" [label]="'Nombre de places'" [inputType]="'number'"
                [isLengthLimited]="false" [placeholder]="'Indiquer le nombre de places'"
                [control]="castFormControl('availablePlaces')"
                (inputChanged)="onInputChange($event, 'availablePlaces')">
            </app-webiat-text-input>
        </div>
        <app-webiat-text-input class="first-section-input" [label]="'Instructeur de cours'" [isLengthLimited]="false"
            [placeholder]="'Indiquer le nom de l’instructeur'" [control]="castFormControl('instructor')"
            (inputChanged)="onInputChange($event, 'instructor')">
        </app-webiat-text-input>
    </div>
    <div class="course-modal-footer">
        <button class="submit-btn" [disabled]="!courseForm.valid" (click)="continue()">
            Continuer
        </button>
    </div>
</div>

<ng-template #loader>
    <div class="spinner-wrapper">
        <mat-spinner [diameter]="30"></mat-spinner>
        <span class="search-loading-text">En cours de recherche…</span>
    </div>
</ng-template>
